var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered has-text-weight-medium is-size-5"},[_vm._v(" © 2019 - 2020 Helot Company Inc. ")])}
var staticRenderFns = []

export { render, staticRenderFns }